/**
 * The strength a customer last bought at, kept so a product page opens at their
 * strength and does not ask again.
 *
 * The key holds one option value, e.g. "+2.0". It does not expire: a reading
 * strength changes over years, and the value is corrected as soon as the
 * customer buys at another strength. An expiry sends a returning customer back
 * to the wrong strength for no gain.
 *
 * snippets/preferred-strength.liquid reads the key. Change the two together.
 */
export const PREFERRED_STRENGTH_KEY = 'preferred_strength';

function localStorageOrNull() {
  try {
    return window.localStorage;
  } catch (error) {
    return null;
  }
}

/**
 * @param {string|null} strength
 * @param {Storage|null} [storage]
 */
export function savePreferredStrength(strength, storage = localStorageOrNull()) {
  if (!strength) return;
  try {
    storage?.setItem(PREFERRED_STRENGTH_KEY, strength);
  } catch (error) {
    // Safari private mode refuses to write. The preference is a convenience only.
  }
}
